import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { LoginAdmin } from 'src/app/models/login/login-admin';
import { UsuarioLog } from 'src/app/models/login/usuarioLog';
import { LoginService } from 'src/app/services/login/login.services';
import Swal from 'sweetalert2';
import { Title } from "@angular/platform-browser";
import { TITLE_PAGE } from 'src/app/constantes/title-page';
import { Cifrado } from 'src/app/cifrado/cifrado';

interface usuario {
  nombre: string,
  apellido: string,
  num: any
}
interface documento {
  tipo: string,
  nombre: string
}

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  contrasenaSofiaPLus: string = "";
  usuario: LoginAdmin = {
    carUsuPersonaLogin: null,
    carUsuPersona: null,
    contrasena: '',
    corElectronico: '',
    numDocUsuPersona: ''
  }
  usuarioCand: LoginAdmin = {
    carUsuPersonaLogin: null,
    carUsuPersona: null,
    contrasena: '',
    numDocUsuPersona: '',
    tipoDocumento: 'CC'
  }
  usuarioGuardar: UsuarioLog = {
    nombre: '',
    apellido: '',
    num: 0,
    dependencia: '',
    regional: '',
  }
  user: string;
  pasw: string;
  admin = false;
  candidato = true;
  objetoPrueba = {
    prueba: [],
    id: 0
  };
  tipo: string;
  numeroCandito: any;
  passwC = '';
  opciones = ['compe1', 'compe2', 'compe3'];
  pruebas: string[] = []
  //documentos = ['Cédula de ciudadanía', 'Tarjeta de identidad', 'Cédula de extranjeria', 'PEP'];
  documentos: documento[] = [
    {
      tipo: 'CC',
      nombre: 'Cédula de ciudadanía'
    },
    {
      tipo: 'TI',
      nombre: 'Tarjeta de identidad'
    },
    {
      tipo: 'CE',
      nombre: 'Cédula de extranjería'
    },
    {
      tipo: 'PS',
      nombre: 'Pasaporte'
    },
    {
      tipo: 'NCS',
      nombre: 'Número ciego Sena'
    },
    {
      tipo: 'DNI',
      nombre: 'Documento Nacional de Identificación'
    },
    {
      tipo: 'NIS',
      nombre: 'Número de Identificación Tributaría'
    },
    {
      tipo: 'PEP',
      nombre: 'PEP'
    },
    {
      tipo: 'PPT',
      nombre: 'Permiso por Protección Temporal'
    }
  ];

  adminLogin: any = {};
  candidatoLogin: any = {};

  constructor(
    private router: Router,
    private loginServices: LoginService,
    private titleService: Title,
    private cifrado: Cifrado
  ) {
    // this.titleService.setTitle("MVO-Login");
    // sessionStorage.clear();
    this.titleService.setTitle("Iniciar sesión: "+ TITLE_PAGE );
    localStorage.setItem('poblacion', '');
    localStorage.setItem('municipio', '');
  }

  ayuda() {
    if (this.admin) {
      Swal.fire({
        icon: 'question',
        title: 'Ayuda para portal de MVO Sena',
        text: 'El acceso a la plataforma Orienta Sena solo está disponible para funcionarios y contratistas previamente registrados y se requiere tener correo institucional y contraseña asignados. Para obtener mayor información, enviar sus inquietudes al correo mesadeservicio@sena.edu.co.',
        confirmButtonColor: '#3ba936 ',

        confirmButtonText: 'Volver'

      })

    }
    if (this.candidato) {
      Swal.fire({
        icon: 'question',
        title: 'Ayuda para portal de MVO Sofia plus',
        text: 'Para acceder a la presentación de pruebas de Orientación Vocacional y consulta de los resultados obtenidos, debe estar previamente registrados en Sofia Plus, en caso de no estarlo dirigirse a la opción Regístrate del Inicio de Sesión. Para obtener mayor información, enviar sus inquietudes al correo mesadeservicio@sena.edu.co.',
        confirmButtonColor: '#3ba936 ',

        confirmButtonText: 'Volver'

      })
    }

  }
  ingresar() {
    var CryptoJS = require("crypto-js");
    
    localStorage.setItem('estado', '1');

    if (this.admin) {
      localStorage.setItem('us', 'admin')

      this.usuario.corElectronico = this.cifrado.encriptar(this.adminLogin.corElectronico);
      this.usuario.numDocUsuPersona = this.cifrado.encriptar(this.adminLogin.numDocUsuPersona);
      this.usuario.contrasena = this.cifrado.encriptar(this.adminLogin.contrasena);
      this.usuario.carUsuPersonaLogin = this.cifrado.encriptar('1');
   


      this.loginServices.postLogin(this.usuario).subscribe(data => {
     
        if (data.resultado == 'OK') {
          this.usuarioGuardar.apellido = data.apeUsuPersona;
          this.usuarioGuardar.nombre = data.nomUsuPersona;
          this.usuarioGuardar.num = data.numDocUsuPersona;
          this.usuarioGuardar.dependencia = data.dependencia;
          this.usuarioGuardar.regional = data.regional;
          this.loginServices.setUsuario(this.usuarioGuardar);

          localStorage.setItem('apellido', this.usuarioGuardar.apellido);
          localStorage.setItem('nombre', this.usuarioGuardar.nombre);
          localStorage.setItem('num', this.usuarioGuardar.num);
          localStorage.setItem('dependencia', this.usuarioGuardar.dependencia);
          localStorage.setItem('regional', this.usuarioGuardar.regional);
          localStorage.setItem('xzs', data.idUsuPersona);
          localStorage.setItem('poblacion', data.tipoPoblacion);


          sessionStorage.token = data.token;
          sessionStorage.inicioSesion = moment(new Date()).format('YYYY-MM-DD HH:mm');
          // sessionStorage.cierreSesion = moment(new Date()).add(1, 'hours').format('YYYY-MM-DD HH:mm');
          Swal.fire({
            icon: 'success',
            title: 'Bienvenido',

            text: data.nomUsuPersona + ' ' + data.apeUsuPersona + '<br>' + 'hola',
            html: '<p>'+ data.nomUsuPersona + ' ' + data.apeUsuPersona + '<br><br>'+ data.regional + '<br>'+data.dependencia +  '</p>',
            showConfirmButton: true,
            confirmButtonText: 'Continuar',
          
            onAfterClose: () => this.router.navigate(['/dashboard/inicio'])
          });
        } else {
          
          Swal.fire({
            icon: 'error',
            title: 'Incorrecto',
            text: data.mensajeError
          });
        }
      }, error => {
        Swal.fire({
          icon: 'error',
          title: 'Problema de conexión ',
          text: 'Pongase en contacto con admnistrador'
        })
      })
    }

    if (this.candidato) {
      this.usuarioCand.tipoDocumento = this.cifrado.encriptar(this.candidatoLogin.tipoDocumento);
      this.usuarioCand.numDocUsuPersona = this.cifrado.encriptar(this.candidatoLogin.numDocUsuPersona);
      this.usuarioCand.contrasena = this.cifrado.encriptar(this.contrasenaSofiaPLus);
      this.usuarioCand.carUsuPersonaLogin = this.cifrado.encriptar('2');


      this.loginServices.postLogin(this.usuarioCand).subscribe(data => {
        
        if (data.resultado == 'OK') {
          this.usuarioGuardar.apellido = data.apeUsuPersona;
          this.usuarioGuardar.nombre = data.nomUsuPersona;
          this.usuarioGuardar.num = data.numDocUsuPersona;
          this.loginServices.setUsuario(this.usuarioGuardar);
          sessionStorage.token = data.token;
          localStorage.setItem('apellido', this.usuarioGuardar.apellido);
          localStorage.setItem('nombre', this.usuarioGuardar.nombre);
          localStorage.setItem('num', this.usuarioGuardar.num);
          localStorage.setItem('xzs', data.idUsuPersona);
          localStorage.setItem('nis', data.nis);
          localStorage.setItem('poblacion', data.tipoPoblacion);
          localStorage.setItem('municipio', data.municipio);
          localStorage.setItem('manejoErrores', 'false');
          sessionStorage.inicioSesion = moment(new Date()).format('YYYY-MM-DD HH:mm');
        
          
          localStorage.setItem('us', 'cand')
          Swal.fire({
            icon: 'success',
            title: 'Bienvenido' + ' ' + data.nomUsuPersona + ' ' + data.apeUsuPersona,
            text: 'Se recomienda tener actualizados los datos de Sena Sofia Plus, para poder brindar un mejor servicio',
            showConfirmButton: true,
            confirmButtonText: 'Continuar',
            onAfterClose: () => this.router.navigate(['/dashboard/inicio'])
          });
        }
        else {
       
          Swal.fire({
            icon: 'error',
            title: 'Incorrecto',
            text: data.mensajeError
          });
        }
      }, error => {
        Swal.fire({
          icon: 'error',
          title: 'Problema de conexión ',
          text: 'Pongase en contacto con admnistrador'
        })
      })
     
    }

    if (this.user == 'admin' && this.pasw == 'admin') {
      localStorage.setItem('us', 'admin')
      this.router.navigate(['/dashboard']);
    }

  }
  login(tipo: string) {

    document.getElementById('irFormulario').focus();
    if (tipo === 'admin') {
      this.admin = true;
      this.candidato = false;
      this.usuarioCand.numDocUsuPersona = null
    }
    if (tipo === 'candidato') {
      this.candidato = true;
      this.admin = false;
      this.usuarioCand.numDocUsuPersona = null
      this.usuarioCand.contrasena = null
    }
  }
  prueba() {
    console.log(this.objetoPrueba);

  }
  ngOnInit(): void {
  }

  irContenido() {
    document.getElementById('irLogin').focus();
  }

  btonContenido(event) {
    if (event.keyCode == 9) {
      document.getElementById('irBotonContenido').focus();
    }
  }
  volver() {
    this.router.navigate(['/inicio']);
  }
}
